import { DevicePid } from './define'
// RoYuan
const RoYuanMg68Devices: DevicePid[] = [
  DevicePid.IROKMg68Max_24g,
  DevicePid.IROKMg68Max,
  DevicePid.IROKMg68LITE,
  DevicePid.IROKMg68Pro,
  DevicePid.IROKMg68SE,
  DevicePid.IROKMg68,
  DevicePid.IROKMG68ACE,
  DevicePid.IROKMG68ACE_UpPlus,
  DevicePid.IROKMG68ACE_W,
  DevicePid.IROKMG68ACE_W_24g,
]
// RoYuan
export const RoYuanMars68Devices: DevicePid[] = [
  DevicePid.CarotmasMars68Pro,
  DevicePid.CarotmasMars68Pro_Wireless,
  DevicePid.CarotmasMars68Pro_Wireless_24g,
  DevicePid.CarotmasMars68,
  DevicePid.CarotmasMars68SE,
  DevicePid.CarotmasMars68_Wireless,
  DevicePid.CarotmasMars68_Wireless_24g,
]
export const HuochaiDevice: DevicePid[] = [DevicePid.IROKMG63, DevicePid.IROKRA68_1, DevicePid.IROKMG75V2C12]

const MonsGeekDevices: DevicePid[] = [DevicePid.MonsGeek, DevicePid.MonsGeek_NoLight, DevicePid.MonsGeek_NoLight_24g]
// JingTai
export const JingTaiMg75Devices: DevicePid[] = [DevicePid.IROKMg75, DevicePid.IROKMg75PRO]
// JingTai
export const JingTaiMer68Devices: DevicePid[] = [DevicePid.CarotmasMer68, DevicePid.CarotmasMer68Pro]

// RoYuan
export const RoYuanMer68Devices: DevicePid[] = [DevicePid.CarotmasMer68SE, DevicePid.CarotmasMer68Lite]

export const RoYuanND68Devices: DevicePid[] = [DevicePid.IROKND68]
export const RoYuanND63Devices: DevicePid[] = [DevicePid.IROKND63Max]
export const RoYuanDevice24GList: DevicePid[] = [DevicePid.IROKMg68Max_24g, DevicePid.CarotmasMars68Pro_Wireless_24g, DevicePid.CarotmasMars68_Wireless_24g, DevicePid.IROKMG68ACE_W_24g]

// RoYuan
export const RoYuanDeviceList: DevicePid[] = [...RoYuanMars68Devices, ...MonsGeekDevices, ...RoYuanMg68Devices, ...RoYuanMer68Devices, ...RoYuanND68Devices, ...RoYuanND63Devices]

export const RoYuanDeviceList_0005: DevicePid[] = [DevicePid.IROKMG68ACE, DevicePid.IROKMG68ACE_UpPlus, DevicePid.IROKMG68ACE_W, DevicePid.IROKMG68ACE_W_24g, ...RoYuanND68Devices, ...RoYuanND63Devices]

export const JingTaiDeviceList: DevicePid[] = [
  DevicePid.IROKNa87Pro,
  DevicePid.IYXMu68Pro,
  DevicePid.IYXMu68Pro_cyan,
  DevicePid.IYXMu68_ULTRA,
  DevicePid.IROKNd63,
  DevicePid.IROKNd63_cyan,

  DevicePid.IYXPolar75,
  ...JingTaiMg75Devices,
  ...JingTaiMer68Devices,
]
export const JingTaiV2DeviceList: DevicePid[] = [DevicePid.IROKMg68Plus, DevicePid.IROKMg75Max, DevicePid.CarotmasMars75, DevicePid.CarotmasMars75Pro, DevicePid.IROKND68Pro, DevicePid.IROKND63Ultra, DevicePid.CarotmasMer68Max, DevicePid.IROKRA68]
export const He6UltraDeviceList: DevicePid[] = [DevicePid.He6Ultra, DevicePid.He6Ultra_24g]
// 华奋达
export const HE3SEMouseDeviceList: DevicePid[] = [DevicePid.IROKHe3SE_Wireless, DevicePid.IROKHe3SE_Wireless_24g]
// 原相
export const AmberDeviceList: DevicePid[] = [DevicePid.IYXAmber358_24g8k, DevicePid.IYXAmber358_Wired]
// 贝盈鼠标
export const HE2MouseDeviceList: DevicePid[] = [DevicePid.IROKHe2]
// 睿联微
export const WitmodDevicesList: DevicePid[] = [DevicePid.IYXMu68, DevicePid.IROKNd75, DevicePid.IROKNA87]
// 贝盈键盘
export const BeiYingDeviceLis: DevicePid[] = [DevicePid.IROKAl87, DevicePid.IROKAl87Pro, DevicePid.IROKAl87Rgb, DevicePid.IROKMg87, DevicePid.IYXOp75, DevicePid.IYXTp87, DevicePid.IYXMt87, DevicePid.IROKFe75Pro, DevicePid.IROKFe98Pro]
// 自己
export const QMKDeviceList: DevicePid[] = [DevicePid.IROKQMKLi75]

export const Fe87v2DeviceList: DevicePid[] = [DevicePid.IrokFe87V2, DevicePid.IrokFe87V2_24g, DevicePid.IrokFe87V2IMC, DevicePid.IrokFe87V2IMC_24g, DevicePid.IrokFe87V2C18]
// FE87 C18 纯机械轴设备（单模 有线，无 2.4G）
export const Fe87C18DeviceList: DevicePid[] = [DevicePid.IrokFe87V2C18]

export const SlefDevMagnetList: DevicePid[] = [DevicePid.CarotmasMer68SESelfDev]

export const MouseDevices: DevicePid[] = [...HE2MouseDeviceList, ...HE3SEMouseDeviceList, ...AmberDeviceList, ...He6UltraDeviceList]

export const supportBluetooth: DevicePid[] = [
  DevicePid.CarotmasMars68Pro_Wireless,
  DevicePid.CarotmasMars68Pro_Wireless_24g,
  DevicePid.IROKMg68Max,
  DevicePid.IROKMg68Max_24g,
  DevicePid.CarotmasMars68_Wireless,
  DevicePid.CarotmasMars68_Wireless_24g,
  ...HE3SEMouseDeviceList,
  ...He6UltraDeviceList,
  ...AmberDeviceList,
  DevicePid.IROKMG68ACE_W,
  DevicePid.IROKMG68ACE_W_24g,
]
